import { ChangeEventHandler, Fragment } from 'react';

import styles from './SkuManagementHeader.module.scss';

type FilterByType = 'store' | 'active' | 'storefrontStatus';

const filterOptions: Record<FilterByType, string[]> = {
    store: ['all', 'google', 'apple', 'amazon', 'xsolla'],
    active: ['all', 'active', 'inactive'],
    storefrontStatus: [
        'all',
        'PUBLISHED',
        'NOT_PUBLISHED',
        'NOT_FOUND',
        'NOT_SYNCED',
        'ERROR',
    ],
};

const filterOptionsDisplayNames: Record<
    FilterByType,
    Record<string, string>
> = {
    store: {
        all: 'All',
        google: 'Google',
        apple: 'Apple',
        amazon: 'Amazon',
        xsolla: 'Xsolla',
    },
    active: {
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
    },
    storefrontStatus: {
        all: 'All',
        PUBLISHED: 'Published',
        NOT_PUBLISHED: 'Not published',
        NOT_FOUND: 'Not found',
        NOT_SYNCED: 'Not synced',
        ERROR: 'Error',
    },
};

const filterDisplayNames: Record<FilterByType, string> = {
    store: 'Store',
    active: 'Active',
    storefrontStatus: 'Storefront status',
};

type SkuManagementHeaderProps = {
    count: number;
    searchString: string;
    onSearchStringChange: ChangeEventHandler<HTMLInputElement>;
    filterValues: Record<FilterByType, string>;
    onFilterChange: ChangeEventHandler<HTMLInputElement>;
    onRefresh: () => void;
};

function SkuManagementHeader(props: SkuManagementHeaderProps) {
    const {
        count,
        searchString,
        onSearchStringChange,
        filterValues,
        onFilterChange,
        onRefresh,
    } = props;

    return (
        <>
            <div className={styles.header}>
                <div>
                    <h1>SKUs ({count})</h1>
                    <button className="new" onClick={onRefresh}>
                        Refresh
                    </button>
                </div>
                <input
                    aria-label="search skus"
                    autoFocus
                    className="editInput"
                    type="text"
                    value={searchString}
                    placeholder="Search..."
                    onChange={onSearchStringChange}
                />
            </div>
            <div className={styles.filters}>
                {(
                    Object.entries(filterOptions) as [FilterByType, string[]][]
                ).map(([filterBy, options]) => (
                    <fieldset key={filterBy}>
                        <legend>{filterDisplayNames[filterBy]}</legend>
                        {options.map((option) => (
                            <Fragment key={`${filterBy}-${option}`}>
                                <input
                                    defaultChecked={
                                        filterValues[filterBy] === option
                                    }
                                    id={`${filterBy}-${option}`}
                                    name={filterBy}
                                    type="radio"
                                    value={option}
                                    onChange={onFilterChange}
                                />
                                <label htmlFor={`${filterBy}-${option}`}>
                                    {
                                        filterOptionsDisplayNames[filterBy][
                                            option
                                        ]
                                    }
                                </label>
                            </Fragment>
                        ))}
                    </fieldset>
                ))}
            </div>
        </>
    );
}

export default SkuManagementHeader;
